<template>
  <div class="room-list-wrapper">
    <div class="room-list">
      <fetching-loader
        displayType="displayBlock"
        v-if="loadingRoomObject"
      ></fetching-loader>
      <div class="contentCard" v-else>
        <div class="input-group search-row">
          <div class="input-textfield">
            <label for="searchbar">Search guests</label>
            <input
              type="text"
              @keyup="filterFunction"
              v-model="searchQuery"
              id="searchbar"
            />
          </div>
          <button class="button-positive" @click="multiMessageModal">
            Multimessage guests
          </button>
          <button class="button-positive" @click="importGuestsModal">
            Import guests
          </button>
          <button class="button-negative" @click="checkoutGuestsModal">
            Checkout guests
          </button>
        </div>
        <div
          v-for="(room, key) in hotelRooms"
          class="roomBox"
          :class="{ roomBooked: !room.available }"
          v-show="hotelRoomsFilter[key].isVisible"
          :key="room.roomnumber"
        >
          <div v-if="room.available">
            <span style="color: white">SEAT<br/>{{room.roomnumber}}</span>
            <div class="freeMenu">
              <div v-on:click="checkinModal(room)" class="iconWrap">
                <v-icon name="sign-in-alt" scale="1.6"/>
              </div>
            </div>
          </div>
          <div v-if="!room.available">
            <span style="color: white">
              {{ trimNameForDisplay(room.guestname) }} <br/>
              {{ trimNameForDisplay(room.guestlastname) }}
            </span>
            <div class="freeMenu">
              <div v-on:click="updateRoomModal(room)" class="iconWrap">
                <v-icon name="pencil-alt" scale="1.6"/>
              </div>
              <div v-on:click="quickMessageModal(room)" class="iconWrap">
                <v-icon name="regular/comment-dots" scale="1.6"/>
              </div>
              <div v-on:click="checkoutModal(room)" class="iconWrap">
                <v-icon name="sign-out-alt" scale="1.6"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="fadeInModal">
      <checkin-modal
        v-if="showCheckinModal"
        :selectedRoom="selectedRoom"
      ></checkin-modal>
    </transition>
    <transition name="fadeInModal">
      <checkout-modal
        v-if="showCheckoutModal"
        :selectedRoom="selectedRoom"
      ></checkout-modal>
    </transition>
    <transition name="fadeInModal">
      <update-room
        v-if="showUpdateRoom"
        :selectedRoom="selectedRoom"
      ></update-room>
    </transition>
    <transition name="fadeInModal">
      <quick-message
        v-if="showQuickMessage"
        :selectedRoom="selectedRoom"
      ></quick-message>
    </transition>
    <transition name="fadeInModal">
      <multi-message
        v-if="showMultiMessage"
        :occupiedRooms="occupiedRooms"
      ></multi-message>
    </transition>
    <transition name="fadeInModal">
      <import-guests
        v-if="showImportGuests"
      ></import-guests>
    </transition>
    <transition name="fadeInModal">
      <checkout-guests
          v-if="showCheckoutGuests"
          :occupiedRooms="occupiedRooms">
      </checkout-guests>
    </transition>
  </div>
</template>

<script>
import FetchingLoader from "@/components/GlobalComponents/FetchingLoader";

import MultiMessage from "../RoomsPage/MultimessageComponents/MultiMessage";
import QuickMessage from "../RoomsPage/RoomsModals/QuickMessage.vue";
import UpdateRoom from "../RoomsPage/RoomsModals/UpdateRoom.vue";
import CheckinModal from "../RoomsPage/RoomsModals/CheckinModal.vue";
import CheckoutModal from "../RoomsPage/RoomsModals/CheckoutModal.vue";

import ImportGuests from "../RoomsPage/ImportGuests.vue";
import CheckoutGuests from "../RoomsPage/CheckoutGuests.vue";

import bus from "@/bus.js";
import {db} from "@/firebase";

export default {
  components: {
    CheckinModal,
    CheckoutModal,
    UpdateRoom,
    MultiMessage,
    QuickMessage,
    FetchingLoader,
    ImportGuests,
    CheckoutGuests
  },
  data() {
    return {
      showCheckinModal: false,
      showCheckoutModal: false,
      showQuickMessage: false,
      showUpdateRoom: false,
      showMultiMessage: false,
      showImportGuests: false,
      showCheckoutGuests: false,
      notificationText: "",
      selectedRoom: {},
      loadingRoomObject: true,
      searchQuery: "",
      hotelRoomsFilter: [],
    };
  },
  computed: {
    occupiedRooms: function () {
      const rooms = JSON.parse(JSON.stringify(this.hotelRooms));
      let occupiedRooms = [];
      for (let room in rooms) {
        if (!rooms[room].available) {
          occupiedRooms.push(rooms[room]);
        }
      }
      return occupiedRooms;
    },
  },
  firebase() {
    return {
      hotelRooms: {
        source: db
            .ref(`rooms/${this.$customerId}/${this.$hotelId}/`)
            .orderByChild("sortingNumber"),
        readyCallback: function () {
          for (let index in this.hotelRooms) {
            this.hotelRoomsFilter.push({
              title: this.hotelRooms[index].roomnumber,
              isVisible: true,
            });
          }
          this.loadingRoomObject = false;
        },
      },
    };
  }, //end of firebase
  created() {
    bus.$on("closeCheckinModal", () => {
      this.showCheckinModal = false;
      bus.$emit("bodyOverflow", false);
    });
    bus.$on("closeCheckoutModal", () => {
      this.showCheckoutModal = false;
      bus.$emit("bodyOverflow", false);
    });
    bus.$on("closeUpdateRoomModal", () => {
      this.showUpdateRoom = false;
      bus.$emit("bodyOverflow", false);
    }),
    bus.$on("closeQuickMessage", () => {
      this.showQuickMessage = false;
      bus.$emit("bodyOverflow", false);
    }),
    bus.$on("closeMultiMessage", () => {
      this.showMultiMessage = false;
      bus.$emit("bodyOverflow", false);
    });
    bus.$on("closeCheckoutGuests", () => {
      this.showCheckoutGuests = false;
      bus.$emit("bodyOverflow", false);
    });
    bus.$on('closeImportGuests', () => {
      this.showImportGuests = false;
      bus.$emit('bodyOverflow', false);
    })
  },
  methods: {
    filterFunction() {
      for (let index in this.hotelRooms) {
        this.hotelRoomsFilter[index].isVisible =
          this.hotelRooms[index].roomnumber.includes(this.searchQuery) ||
          this.hotelRooms[index].guestlastname.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          this.hotelRooms[index].guestname.toLowerCase().includes(this.searchQuery.toLowerCase())
        ;
      }
    },
    checkinModal(room) {
      this.showCheckinModal = true;
      this.selectedRoom = JSON.parse(JSON.stringify(room));
      bus.$emit("bodyOverflow", true);
    },
    checkoutModal(room) {
      this.showCheckoutModal = true;
      this.selectedRoom = JSON.parse(JSON.stringify(room));
      bus.$emit("bodyOverflow", true);
    },
    quickMessageModal(room) {
      this.showQuickMessage = true;
      this.selectedRoom = JSON.parse(JSON.stringify(room));
      bus.$emit("bodyOverflow", true);
    },
    updateRoomModal(room) {
      this.showUpdateRoom = true;
      this.selectedRoom = JSON.parse(JSON.stringify(room));
      bus.$emit("bodyOverflow", true);
    },
    multiMessageModal() {
      this.showMultiMessage = true;
      bus.$emit("bodyOverflow", true);
    },
    importGuestsModal() {
      this.showImportGuests = true;
      bus.$emit("bodyOverflow", true);
    },
    checkoutGuestsModal() {
      this.showCheckoutGuests = true;
      bus.$emit("bodyOverflow", true);
    },
    trimNameForDisplay(name = '') {
      return name.substring(0, 15);
    }
  },
};
</script>

<style scoped>
.search-row {
  display: flex;
  justify-content: flex-start;
  margin-left: 10px;
}
#searchbar {
  margin-right: 15px;
}
.search-row button {
  margin: 0 15px;
}
.iconWrap {
  background: #ffffff;
  height: 32px;
  width: 48px;
  margin: 1px;
  cursor: pointer;
  display: flex;
  justify-content: center;
}
* {
  box-sizing: border-box;
}
.room-list-wrapper {
  display: flex;
  width: 100%;
}
.room-list {
  display: flex;
  margin: 0px auto 0px;
  border-radius: 5px;
  padding: 10px;
  padding-top: 20px;
  padding-bottom: 80px;
}
.contentCard {
  margin: 0px auto 0px;
  width: 980px;
}
h1,
h2,
h3,
h4,
p {
  font-weight: 100;
}
.button-global {
  margin: 0 auto;
}
.cardMenu {
  position: fixed;
  z-index: 3;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100px;
  background-color: #f7f7f7;
  border-top: 1px solid #707070;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
}
.roomBox {
  position: relative;
  box-shadow: 2px 2px 20px 0px rgba(0, 0, 0, 0.2);
  display: inline-block;
  margin: 10px;
  width: 170px;
  height: 170px;
  background-color: rgba(46, 91, 86, 0.79);
  border-radius: 8px;
  padding: 25px 15px 35px;
  text-align: center;
  vertical-align: bottom;
}
.roomBox p {
  font-size: 1.8rem;
  margin: 0px;
  margin-top: 5px;
  color: #fff;
  font-weight: var(--weight-medium);
}
.freeMenu {
  display: flex;
  justify-content: center;
  padding-top: 2px;
  margin-left: 20px;
  margin-right: 20px;
  position: absolute;
  bottom: 15px;
  left: 0px;
  right: 0px;
  background-color: white;
  border-radius: 4px;
}
.roomBooked {
  background: linear-gradient(180deg, #b44240 0%, #c64a48 100%);
}
@media (max-width: 760px) {
  .button-global {
    margin: 0px;
  }
}
</style>
